import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import RadioButtons from './radio-button-group';
import { builderDispatch, WebUI } from '../../_utils/ui';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  availableFinishKeys,
  finishValue,
  availableFinishOptions,
  availableDeliveryOptionsForFinish,
  calculateSelectedFinish,
  selectedDeliveryOption,
} from '../common/finish-and-delivery-options';

const handleDeliveryChange = (deliveryOptions, value, onChange) => {
  onChange({
    delivery_option: selectedDeliveryOption(deliveryOptions, value),
  });
};

const handleFinishChange = (
  deliveryOption,
  value,
  finishesByDeliveryOption,
  onChange
) => {
  onChange({
    finish: calculateSelectedFinish(
      deliveryOption.key,
      value,
      finishesByDeliveryOption
    ),
  });
};

const handleShowAllPrices = () => {
  builderDispatch.dispatch({
    type: WebUI.SHOW_PRINTS_PRICES,
  });
};

const Options = props => {
  const {
    finishes,
    finish,
    finishesByDeliveryOption,
    deliveryOption,
    deliveryOptions,
    onChange,
    showAllPricesLink,
    hidePrintFinishes,
  } = props;

  return (
    <div className="options">
      <div
        className={classNames('form-group finish', {
          'd-none': hidePrintFinishes,
        })}>
        <RadioButtons
          id="option-finish"
          options={availableFinishOptions(
            finishes,
            availableFinishKeys(finishesByDeliveryOption, deliveryOption)
          )}
          title="Print Finish"
          value={finishValue(
            finish,
            availableFinishKeys(finishesByDeliveryOption, deliveryOption)
          )}
          onChange={value =>
            handleFinishChange(
              deliveryOption,
              value,
              finishesByDeliveryOption,
              onChange
            )
          }
        />
        <hr />
      </div>
      <div className="form-group delivery">
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */}
        <label htmlFor="option-delivery" className="mb-1">
          Delivery Method*
        </label>
        <button
          aria-label="See Prices"
          className={classNames('btn btn-link btn-underline px-1', {
            'd-none': !showAllPricesLink,
          })}
          role="link"
          type="button"
          onClick={handleShowAllPrices}>
          See Prices
        </button>
        <small className="d-block mb-2">*Prices for each item will vary</small>
        <RadioButtons
          id="option-delivery"
          options={availableDeliveryOptionsForFinish(
            deliveryOptions,
            finishesByDeliveryOption,
            finish
          )}
          value={deliveryOption.key}
          onChange={value =>
            handleDeliveryChange(deliveryOptions, value, onChange)
          }
        />
      </div>
      <hr />
    </div>
  );
};

Options.propTypes = {
  finishes: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish.isRequired,
  finishesByDeliveryOption: PropTypes.objectOf(PropTypes.arrayOf(PrintFinish))
    .isRequired,
  deliveryOption: DeliveryOption.isRequired,
  deliveryOptions: PropTypes.arrayOf(DeliveryOption).isRequired,
  showAllPricesLink: PropTypes.bool,
  hidePrintFinishes: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

Options.defaultProps = {
  finishes: [],
  showAllPricesLink: false,
  hidePrintFinishes: false,
};

export default Options;
